<template>
  <div class="content">
    <div class="header">
      <div></div>
      <div class="header-title">{{ title }}</div>
      <div v-if="dataForm ? dataForm.Status && dataForm.Status === '1' : false" class="header-status status1">设备在线</div>
      <div v-else class="header-status status2">设备离线</div>
    </div>
    <div class="container">
      <div class="item">
        <div class="headTitle">环境湿度（RH%）</div>
        <div class="num">{{ dataForm ? dataForm.RH? (dataForm.RH / 10):"" : "" }}</div>
      </div>
      <div class="item">
        <div class="headTitle">环境温度（°C）</div>
        <div class="num">{{ dataForm ? dataForm.Temp? (dataForm.Temp / 10): "" : "" }}</div>
      </div>
      <div class="item">
        <div class="headTitle">噪声（dB）</div>
        <div class="num">{{ dataForm ? dataForm.dB? (dataForm.dB / 10): "" : "" }}</div>
      </div>
      <div class="item">
        <div class="headTitle">PM2.5（ug/m³）</div>
        <div class="num">{{ dataForm ? dataForm.PM25 || "" : "" }}</div>
      </div>
      <div class="item">
        <div class="headTitle">PM10（ug/m³）</div>
        <div class="num">{{ dataForm ? dataForm.PM100 || "" : "" }}</div>
      </div>
      <div class="item time">最后数据更新于{{ dataForm ? dataForm._terminalTime || "" : "" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "dataInfo"],
  data() {
    return {
      // title: '料仓环境监测',
      status: "设备在线",
      dataForm: null,
    };
  },
  watch: {
    dataInfo(val) {
      this.dataForm = val;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;

  &-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  &-status {
    font-size: 16px;
    font-weight: bold;
    text-align: right;
  }
  div {
    width: 33.33%;
  }
  .status1 {
    color: #67c23a;
  }
  .status2 {
    color: #f56c6c;
  }
}
.container {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: repeat(3, 33.33%);
  .item {
    height: 100%;
    display: flex;
    justify-content: space-between;
    .headTitle {
      width: 50%;
      font-size: 18px;
      display: flex;
      align-items: center;
    }
    .num {
      width: 50%;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .time {
    /* font-size: 18px; */
    display: flex;
    align-items: center;
  }
}
</style>